// External libraries
import createCache from '@emotion/cache';
import stylisRTL from 'stylis-plugin-rtl';

// Internal modules
import { getGlobals } from '@/lib';

const { nonce } = getGlobals();

export const EMOTION_CACHE = {
  ltr: createCache({ key: 'css-ltr', nonce, stylisPlugins: [] }),
  rtl: createCache({ key: 'css-rtl', nonce, stylisPlugins: [stylisRTL] }),
};
